
<marv-drawer #drawerStoresList (onDidDismiss)="this.onDidDismissDrawerStoresList($event)">
    <app-store-list (onSelectStore)="this.onSelectStore($event)"/>
</marv-drawer>

<ion-grid class="no_padding" >        
    <ion-row class="ion-align-items-center ion-justify-content-between"> 
        <ion-col class="title_card">
            {{'MY_OPERATIONS' | translate}}
            <marv-circle>{{this.operationsItemsDisplayed.length}}</marv-circle>
            
        </ion-col>  
        @if(this.displayActiveOperationToggle){
            <ion-col size="auto">
                <form [formGroup]="this.operationsForm">
                    <marv-toggle label="{{'ACTIVES_OPERATIONS_ONLY' | translate}}" formName="activesOnly" [noMargin]="true"/>
                </form>
            </ion-col>
        }
        @if(this.displayStoreSearch){
            <ion-col size="auto" class="no_padding">
                <marv-button label="{{'SEARCH_STORE' | translate}}" icon="storefront-outline" hideLabelDevice="phone" (click)="this.searchStore()" />
            </ion-col> 
        }
    </ion-row>  
    @if(this.storeSelected){
        <ion-row class="ion-align-items-center ion-justify-content-end">
            <ion-col size="12" size-md="6" id="store_selected">              
                <app-store-item [store]="this.storeSelected" />  
                <marv-button icon="close-outline" [rounded]="true" color="secondary" size="small" (click)="this.unselectStore()" />  
            </ion-col>            
        </ion-row>        
    }
</ion-grid>

<div id="operations_list">    
    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>        
    }
    @else {    
        @if(this.operationsItemsDisplayed.length > 0){
            @for(operationItem of this.operationsItemsDisplayed; track operationItem.id){
                <app-operation-item [operation]="operationItem" [displayRemainingDays]="true" [displayQuota]="true" [displayBtnAddIntervention]="true" [disabledBtnAddIntervention]="operationItem.isPlanningClosed || !operationItem.isPlanningOpened" [enableSelectOperation]="false" (onAddIntervention)="this.addIntervention($event)"></app-operation-item>
            }
        } 
        @else{
            <marv-message type="info">{{'MSG_NO_MY_OPERATION' | translate}}</marv-message>
        }
    }
</div>